<p>user-type-config works!</p>
